<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">
      Judges' Cases
    </h2>
    <div v-if="judges.length <= 0" class="text-center pt-16">
      <p class="text-3xl">Loading...</p>
    </div>
    <div v-if="judges.length > 0" class="grid grid-cols-12 gap-6 mt-5">
      <!-- BEGIN: Judges' Cases -->
      <div
        v-for="(judge, key) in judges"
        :key="key"
        class="intro-y col-span-12 sm:col-span-6 xl:col-span-4"
      >
        <div class="box">
          <div class="flex flex-col lg:flex-row items-center p-5">
            <div
              class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
            >
              <router-link
                :to="{ name: 'judge-cases', params: { id: judge.id } }"
                tag="a"
                class="font-medium"
              >
                {{ judge.name }}
              </router-link>
              <div class="text-gray-600 text-xs">{{ judge.designation }}</div>
            </div>
            <!-- <div class="flex mt-4 lg:mt-0">
              <div class="text-theme-9">{{ judge.cases_count }} case(s)</div>
            </div> -->
            <div class="text-theme-9">
              <div class="w-12 py-1 px-2 text-center">
                {{ judge.cases_count }}
              </div>
              <div class="text-center">
                cases
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- BEGIN: Users Layout -->
      <!-- BEGIN: Pagination -->
      <!-- <div class="intro-y col-span-12 text-center">
        <button
          class="button text-white bg-theme-1 shadow-md justify-self-center"
        >
          Load More
        </button>
      </div> -->
      <!-- END: Pagination -->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "JudgesCasesCount",
  data() {
    return {
      judges: [],
      host_url: process.env.VUE_APP_CCD_CLIENT_URL
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.getJudgesCases();
      }
    }
  },
  mounted() {
    this.getJudgesCases();
  },
  methods: {
    getJudgesCases() {
      axios
        .get(`${window.host}/api/judges-cases`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.judges = response.data;
          }
        });
    }
  }
};
</script>
